var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "InformationList" },
    [
      _c("TopNavigation", { attrs: { TopAct: "4" } }),
      _c(
        "div",
        { class: this.$store.state.webNavigator == "pc" ? "" : "pan110" },
        [
          _c("listTopImg", { attrs: { imgType: "3" } }),
          _c(
            "div",
            {
              staticClass: "marginAuto",
              class: this.$store.state.webNavigator == "pc" ? "" : ""
            },
            [
              _c("articlePage", {
                key: _vm.keys,
                attrs: {
                  listType: _vm.informationType,
                  classType: "A7",
                  active: _vm.types,
                  pageIndex: _vm.current,
                  toLeveListPath: _vm.toLeveListPath
                },
                on: { getTotal: _vm.getTotal }
              }),
              _c("Pagination", {
                attrs: {
                  total: _vm.total,
                  display: 12,
                  "current-page": _vm.current
                },
                on: { pagechange: _vm.getPage }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("FooterNavigation")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5631f7f4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5631f7f4","hasScoped":false,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/InformationList/InformationList.vue
// module id = 1173
// module chunks = 5